/*
 * @Description: 制作视频配音路由
 * 
 */

const routes = [
  // 制作视频配音课件
  {
    path: '/mineMaterials/createVideoDubbing',
    name: 'mineMaterials/createVideoDubbing',
    meta: { title: "制作视频配音" },
    component: () => import('../pages/createVideoDubbing/editBook.vue'),
  },
  // 制作视频配音
  {
    path: '/mineMaterials/createVideoDubbing/editVideo',
    name: 'mineMaterials/createVideoDubbing/editVideo',
    meta: {
      title: '制作视频配音'
    },
    component: () => import('@/pages/createVideoDubbing/editVideo.vue'),
  },
]

export default routes